import React, { useState } from 'react';

const CollapsibleSection = ({ 
  title, 
  children, 
  defaultExpanded = false,
  icon = null,
  className = ""
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-section ${className} ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="collapsible-header" onClick={toggleExpanded}>
        <div className="collapsible-title">
          {icon && <span className="collapsible-icon">{icon}</span>}
          <span className="collapsible-text">{title}</span>
        </div>
        <div className="collapsible-toggle">
          <span className={`toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
            ▼
          </span>
        </div>
      </div>
      
      <div className={`collapsible-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="collapsible-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleSection;